export default __webpack_public_path__ + "static/media/Ascher@2x.1b70470e.png";